import React from "react";

import { ReactComponent as StarIcon } from "../../../assets/icons/star-fill.svg";

const ShutterbReviews = ({ review }) => {
  return (
    <div className="px-2 px-md-4 px-lg-5">
      <h4 className="label-content">
        {review?.user?.firstName + " " + review?.user?.lastName}
      </h4>
      <div className="stars pointer-events-none">
        {[...Array(review.reviews)].map((_, index) => (
          <StarIcon key={index} className="review-stars" />
        ))}
      </div>
      <p className="text-content mt-2">{review.feedback}</p>
    </div>
  );
};

export default ShutterbReviews;
